import {
  InputHTMLAttributes,
  CSSProperties,
  TextareaHTMLAttributes,
  useRef,
  useEffect,
} from 'react';
import { useField } from '@unform/core';
import * as S from './styles';

type Props = InputHTMLAttributes<HTMLInputElement> &
  TextareaHTMLAttributes<HTMLTextAreaElement> & {
    label: string;
    name: string;
    containerStyle?: CSSProperties;
    multiline?: boolean;
    helperText?: string;
  };

const Input = ({
  label,
  name,
  multiline,
  helperText,
  containerStyle,
  ...rest
}: Props) => {
  const inputRef = useRef(null);
  const { fieldName, defaultValue, registerField, error } = useField(name);

  useEffect(() => {
    registerField({
      name: fieldName,
      getValue: ref => {
        return ref.value;
      },
      setValue: (ref, value) => {
        // eslint-disable-next-line no-param-reassign
        ref.value = value;
      },
      clearValue: ref => {
        // eslint-disable-next-line no-param-reassign
        ref.value = '';
      },
      ref: inputRef.current,
    });
  }, [fieldName, registerField]);

  return (
    <S.Container style={containerStyle} hasError={!!error}>
      <label htmlFor={name}>{label}</label>
      {multiline ? (
        <textarea
          ref={inputRef}
          defaultValue={defaultValue}
          name={name}
          id={name}
          {...rest}
        />
      ) : (
        <input
          ref={inputRef}
          name={name}
          id={name}
          defaultValue={defaultValue}
          {...rest}
        />
      )}
      {error && <S.Error>{error}</S.Error>}
      {helperText && <S.HelperText>{helperText}</S.HelperText>}
    </S.Container>
  );
};

Input.defaultProps = {
  multiline: false,
  helperText: '',
  containerStyle: {},
};

export default Input;
